export default __webpack_public_path__ + "static/media/l.0dd040b6.jpg";